import { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import getObjectsAction from "../actions/get-objects.actions";
import { ObjectsState } from "domain/objects/entities/interfaces/object-state.interface";

const getObjectsCases = (builder: ActionReducerMapBuilder<ObjectsState>) => {
  builder.addCase(getObjectsAction.pending, (state) => {
    state.isLoadingObjects = true;
  });
  builder.addCase(getObjectsAction.fulfilled, (state, action) => {
    state.objects = action.payload || [];
    state.isLoadingObjects = false;
  });
  builder.addCase(getObjectsAction.rejected, (state) => {
    state.isLoadingObjects = false;
  });
};

export default getObjectsCases;
